import { Button } from "@/components/ui/button";
import { useEffect, useState, useRef, useMemo } from "react";
import VariableList from "@/components/InputVariableConfigurator/VariableList";
import { Variable } from "@/components/InputVariableConfigurator/types";
import useAutoScroll from "@/components/InputVariableConfigurator/hooks/useAutoScroll";

interface MultipleAssertionsProps {
  assertions: string[];
  onAssertionsChange: (assertions: string[]) => void;
}

export const MultipleAssertions = ({
  assertions,
  onAssertionsChange,
}: MultipleAssertionsProps) => {
  const [newAssertions, setNewAssertions] = useState<string[]>(assertions);
  const ref = useRef<HTMLDivElement>(null);

  const variables = useMemo(
    () =>
      newAssertions.map((assertion, index) => ({
        key: assertion,
        value: assertion,
        id: index.toString(),
      })),
    [newAssertions],
  );

  const { lastItemRef } = useAutoScroll(variables, ref);

  useEffect(() => {
    onAssertionsChange(newAssertions);
  }, [newAssertions, onAssertionsChange]);

  return (
    <div className="col-span-2 flex flex-col gap-y-2">
      <div ref={ref} className="col-span-2 max-h-[170px] overflow-y-auto">
        <VariableList
          variables={variables}
          className="!h-[72px]"
          placeholder="Answer is written in English with no grammar mistakes"
          tooltip="Assertion description"
          hideKey
          updateInputVariable={(variable: Variable, index: number) => {
            const stringValue =
              typeof variable.value === "object"
                ? JSON.stringify(variable.value)
                : String(variable.value);

            setNewAssertions((currentAssertions) =>
              currentAssertions.map((assertion, i) =>
                i === index ? stringValue : assertion,
              ),
            );
          }}
          removeInputVariable={(index: number) => {
            setNewAssertions((currentAssertions) =>
              currentAssertions.filter((_, i) => i !== index),
            );
          }}
          lastItemRef={lastItemRef}
        />
      </div>
      <Button
        onClick={() => setNewAssertions([...newAssertions, ""])}
        className="col-span-2"
      >
        Add Assertion
      </Button>
    </div>
  );
};
